module.exports = __webpack_public_path__ + "img/icon-edit-white.c02dcf85.svg";